import React from 'react'
import PropTypes from 'prop-types'

const CellFooter = ({ action, allData, colName }) => {
	let calculatedValue
	const sumValue = allData.reduce((sum, item) => {
		const cellValue = +item[colName]
		/*if(typeof item[colName] === 'undefined') {
			throw new Error(`Unable to get sum of '${colName}'. Column '${colName}' doesn't exist in a table.`)
		}*/
		if(Object.keys(item).indexOf(colName) < 0) {
			throw new Error(`Unable to get sum of '${colName}'. Column '${colName}' doesn't exist in a table.`)
		}
		if(isNaN(cellValue)) {
			// throw new Error(`Unable to get sum of '${colName}'. Value '${item[colName]}' in '${colName}' is not a number.`)
			// console.log(`Unable to get sum of '${colName}'. Value '${item[colName]}' in '${colName}' is not a number.`)
			return '-'
		}
		return sum + cellValue
	}, 0)

	switch(action) {
		case 'sum':
			calculatedValue = Math.round(sumValue * 100) / 100
			break
		case 'average':
			const quantityItems = allData.length
			calculatedValue = (Math.round(sumValue / quantityItems * 100) / 100).toFixed(2)
			break
		default: calculatedValue = 0
	}

	return(
		<span>{(calculatedValue || calculatedValue === 0) ? calculatedValue : ''}</span>
	)
}

CellFooter.propTypes = {
	action: PropTypes.oneOf(['sum', 'average']).isRequired,
	allData: PropTypes.array.isRequired,
	colName: PropTypes.string.isRequired
}

CellFooter.defaultProps = {
	action: 'sum'
}

export default CellFooter
